import defaultApi from '@/utils/request';

export default {
  // =========================== S33W2001 Start =========================
  S33W2001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2001_Load',
      params,
    });
  },
  S33W2001_IndexViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S13/S33/S33W2001_IndexViewSend',
      data,
    });
  },
  S33W2001_GeneralViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S13/S33/S33W2001_GeneralViewSend',
      data,
    });
  },
  S33W2001_SportViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S13/S33/S33W2001_SportViewSend',
      data,
    });
  },
  S33W2001_Load_0C01_01(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2001_Load_0C01_01',
      params,
    });
  },
  S33W2001_Load_0C01_02(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2001_Load_0C01_02',
      params,
    });
  },
  S33W2001_Load_0C01_03(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2001_Load_0C01_03',
      params,
    });
  },

  // =========================== S33W2001 End =========================
  // =========================== S33W2002 Start =========================
  S33W2002_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2002_Load',
      params,
    });
  },
  S33W2002_IndexViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S13/S33/S33W2002_IndexViewSend',
      data,
    });
  },

  // =========================== S33W2002 End =========================
  // =========================== S33W2003 Start =========================
  S33W2003_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2003_Load',
      params,
    });
  },
  S33W2003_IndexViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S13/S33/S33W2003_IndexViewSend',
      data,
    });
  },

  // =========================== S33W2003 End =========================
  // =========================== S33W2004 Start =========================
  S33W2004_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2004_Load',
      params,
    });
  },
  S33W2004_IndexViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S13/S33/S33W2004_IndexViewSend',
      data,
    });
  },
  S33W2004_Load_0A04_02(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2004_Load_0A04_02',
      params,
    });
  },
  S33W2004_Load_0A04_insC(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2004_Load_0A04_insC',
      params,
    });
  },
  S33W2004_Load_0A04_02D_011(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2004_Load_0A04_02D_011',
      params,
    });
  },
  S33W2004_Load_0A04_insD(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2004_Load_0A04_insD',
      params,
    });
  },
  S33W2004_Load_0A04_02G_011(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2004_Load_0A04_02G_011',
      params,
    });
  },
  S33W2004_Load_0A04_02G_02(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2004_Load_0A04_02G_02',
      params,
    });
  },
  S33W2004_Load_0A04_insG(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2004_Load_0A04_insG',
      params,
    });
  },

  // =========================== S33W2004 End =========================
  // =========================== S33W2005 Start =========================
  S33W2005_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2005_Load',
      params,
    });
  },
  S33W2005_IndexViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S13/S33/S33W2005_IndexViewSend',
      data,
    });
  },
  S33W2005_Load_0A05_02(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2005_Load_0A05_02',
      params,
    });
  },
  S33W2005_Load_0A05_ins(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2005_Load_0A05_ins',
      params,
    });
  },
  S33W2005_Load_0A05_insG(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2005_Load_0A05_insG',
      params,
    });
  },
  S33W2005_Load_0A05_ins2(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2005_Load_0A05_ins2',
      params,
    });
  },

  // =========================== S33W2005 End =========================
  // =========================== S33W2006 Start =========================
  S33W2006_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2006_Load',
      params,
    });
  },
  S33W2006_CourseAddViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2006_CourseAddViewLoad',
      params,
    });
  },
  S33W2006_CourseListViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2006_CourseListViewLoad',
      params,
    });
  },
  S33W2006_IndexViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S13/S33/S33W2006_IndexViewSend',
      data,
    });
  },
  S33W2006_IndexViewCancel(data) {
    return defaultApi({
      method: 'post',
      url: 'S13/S33/S33W2006_IndexViewCancel',
      data,
    });
  },
  S33W2006_UnitSelectorLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2006_UnitSelectorLoad',
      params,
    });
  },
  S33W2006_Load_0A04_02A_01(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2006_Load_0A04_02A_01',
      params,
    });
  },
  S33W2006_Load_0A04_02A_02(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2006_Load_0A04_02A_02',
      params,
    });
  },
  S33W2006_Load_0A04_02A_021(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2006_Load_0A04_02A_021',
      params,
    });
  },
  S33W2006_Load_0A04_insA(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2006_Load_0A04_insA',
      params,
    });
  },
  S33W2006_Load_0A04_02B_011(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2006_Load_0A04_02B_011',
      params,
    });
  },
  S33W2006_Load_0A04_02B_02(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2006_Load_0A04_02B_02',
      params,
    });
  },
  S33W2006_Load_0A04_02B_022(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2006_Load_0A04_02B_022',
      params,
    });
  },
  S33W2006_Load_0A04_02B_023(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2006_Load_0A04_02B_023',
      params,
    });
  },
  S33W2006_Load_0A04_insB(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2006_Load_0A04_insB',
      params,
    });
  },
  S33W2006_Load_0A04_insB2(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2006_Load_0A04_insB2',
      params,
    });
  },

  // =========================== S33W2006 End =========================
  // =========================== S33W2007 Start =========================
  S33W2007_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2007_Load',
      params,
    });
  },
  S33W2007_IndexViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S13/S33/S33W2007_IndexViewSend',
      data,
    });
  },

  // =========================== S33W2007 End =========================
  // =========================== S33W2008 Start =========================
  S33W2008_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2008_Load',
      params,
    });
  },
  S33W2008_IndexViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S13/S33/S33W2008_IndexViewSend',
      data,
    });
  },

  // =========================== S33W2008 End =========================
  // =========================== S33W2009 Start =========================
  S33W2009_Load_0B01_02(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2009_Load_0B01_02',
      params,
    });
  },
  S33W2009_IndexViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S13/S33/S33W2009_IndexViewSend',
      data,
    });
  },
  S33W2009_Load_0B00_prt(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2009_Load_0B00_prt',
      params,
    });
  },

  // =========================== S33W2009 End =========================
  // =========================== S33W2010 Start =========================
  S33W2010_Load_0B02_p(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2010_Load_0B02_p',
      params,
    });
  },
  S33W2010_IndexViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S13/S33/S33W2010_IndexViewSend',
      data,
    });
  },

  // =========================== S33W2010 End =========================
  // =========================== S33W2011 Start =========================
  S33W2011_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2011_Load',
      params,
    });
  },
  S33W2011_Load_0M01_d01(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2011_Load_0M01_d01',
      params,
    });
  },
  S33W2011_Load_0M01_a01(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2011_Load_0M01_a01',
      params,
    });
  },
  S33W2011_Load_0M01_a02(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2011_Load_0M01_a02',
      params,
    });
  },
  S33W2011_Load_0M01_sub(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2011_Load_0M01_sub',
      params,
    });
  },
  S33W2011_IndexViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S13/S33/S33W2011_IndexViewSend',
      data,
    });
  },
  S33W2011_IndexViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S13/S33/S33W2011_IndexViewDelete',
      data,
    });
  },

  // =========================== S33W2011 End =========================
  // =========================== S33W2012 Start =========================
  S33W2012_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2012_Load',
      params,
    });
  },
  S33W2012_IndexViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S13/S33/S33W2012_IndexViewSend',
      data,
    });
  },

  // =========================== S33W2012 End =========================
  // =========================== S33W2013 Start =========================
  S33W2013_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W2013_Load',
      params,
    });
  },
  S33W2013_IndexViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S13/S33/S33W2013_IndexViewSend',
      data,
    });
  },

  // =========================== S33W2013 End =========================
  // =========================== S33W4001 Start =========================
  S33W4001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W4001_Load',
      params,
    });
  },
  S33W4001_Load_0C01_01(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W4001_Load_0C01_01',
      params,
    });
  },
  S33W4001_Load_0C01_02(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W4001_Load_0C01_02',
      params,
    });
  },
  S33W4001_Load_0C01_03(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W4001_Load_0C01_03',
      params,
    });
  },

  // =========================== S33W4001 End =========================
  // =========================== S33W4002 Start =========================
  S33W4002_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W4002_Load',
      params,
    });
  },
  S33W4002_Load_0A06_02(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W4002_Load_0A06_02',
      params,
    });
  },

  // =========================== S33W4002 End =========================
  // =========================== S33W4003 Start =========================
  S33W4003_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W4003_Load',
      params,
    });
  },

  // =========================== S33W4003 End =========================
  // =========================== S33W4004 Start =========================
  S33W4004_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W4004_Load',
      params,
    });
  },
  S33W4004_IndexViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S13/S33/S33W4004_IndexViewSend',
      data,
    });
  },

  // =========================== S33W4004 End =========================
  // =========================== S33W4005 Start =========================
  S33W4005_Load_0B03_02(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W4005_Load_0B03_02',
      params,
    });
  },

  // =========================== S33W4005 End =========================
  // =========================== S33W4006 Start =========================
  S33W4006_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W4006_Load',
      params,
    });
  },
  S33W4006_Load_prt(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W4006_Load_prt',
      params,
    });
  },

  // =========================== S33W4006 End =========================
  // =========================== S33W4007 Start =========================
  S33W4007_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W4007_Load',
      params,
    });
  },

  // =========================== S33W4007 End =========================
  // =========================== S33W4008 Start =========================
  S33W4008_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S13/S33/S33W4008_Load',
      params,
    });
  },

  // =========================== S33W4008 End =========================
  // 加載列表: S33W9004
  S33W9004_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S33/S33W9004_Load',
      params,
    });
  },
  S33W9004_getSybList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S33/S33W9004_getSybList',
      params,
    });
  },
  S33W9004_getS32topic(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S33/S33W9004_getS32topic',
      params,
    });
  },
  S33W9004_getFilelist(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S33/S33W9004_getFilelist',
      params,
    });
  },
  S33W9004_SaveApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S33/S33W9004_SaveApply',
      data,
    });
  },
  S33W9004_handleAct(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S33/S33W9004_handleAct',
      data,
    });
  },
  S33W9004_SaveCopy(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S33/S33W9004_SaveCopy',
      data,
    });
  },
  S33W9004_TopicViewFileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S33/S33W9004_TopicViewFileUpload',
      data,
    });
  },
  S33W9004_TopicViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S33/S33W9004_TopicViewFileDelete',
      data,
    });
  },
  // 加載列表: S33W9005
  S33W9005_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S33/S33W9005_Load',
      params,
    });
  },
  S33W9005_SaveApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S33/S33W9005_SaveApply',
      data,
    });
  },
  // ---------- S339006 ------------------------------
  S33W9006_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S33/S33W9006_Load',
      params,
    });
  },
  S33W9006_SaveApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S33/S33W9006_SaveApply',
      data,
    });
  },
  // ---------- S339002 ------------------------------
  S33W9002_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S33/S33W9002_Load',
      params,
    });
  },
  S33W9002_SaveApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S33/S33W9002_SaveApply',
      data,
    });
  },
  // -------------------- S33W9003 -----------------------
  S33W9003_Get_AuditData(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S33/S33W9003_Get_AuditData',
      params,
    });
  },
  S33W9003_GetReviewListByID(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S33/S33W9003_GetReviewListByID',
      params,
    });
  },
  S33W9003_agreeApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S33/S33W9003_agreeApply',
      data,
    });
  },
  S33W9003_disagreeApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S33/S33W9003_disagreeApply',
      data,
    });
  },
  S33W9003_returnSign(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S33/S33W9003_returnSign',
      data,
    });
  },
  // ---------- S339001 ------------------------------
  S33W9001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S33/S33W9001_Load',
      params,
    });
  },
  S33W9001_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S33/S33W9001_Query',
      params,
    });
  },
  S33W9001_SaveApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S33/S33W9001_SaveApply',
      data,
    });
  },
};
